package streetlight.web.ui

import koala.html.Id

object PopoverId {
    val StarMenu = Id("star-menu-popover")
    val CreatePost = Id("create-post-popover")
    val Curator = Id("curator-popover")
}